import { Link } from "wouter";

import { NewsForm } from "./ui/form";
import { Footer } from "./footer";
import { Video } from "./ui/video";

export const Home = () => {
  return (
    <>
      <div className="main">
        <section className="statement">
          <h1>Super Symmetry</h1>
          <p>
            The series of works Super Symmetry explores the relationship between
            truth and fiction in our perception of reality. Sam draws on
            mathematical and scientific theories, generating complex
            abstractions and deterministic patterns.
          </p>
        </section>
        <Video
          classes="hero-image"
          poster="assets/images/SS-70_1.jpg"
          fullMp="assets/videos/web_vid.mp4"
          fullWebm="assets/videos/web_vid.webm"
        />
        <section id="work" className="grid">
          <div className="grid-element">
            <p>
              We have come to hold a similar theory of duopoly, a binary based
              order where opposites pair-off and require each other to exist.
              Good and evil, light and dark chaos and order. Each piece in the
              series explores not sciences, but societies relationship with the
              duopoly.
              <br />
              <br />
              Mirrors and by extension reflections have the fascinating effect
              of creating another world out of reach, but perfectly
              representative beyond the portal. Your reflection in the mirror
              appears to be mimicking everything you do. Offer to shake it’s
              hand, and it will respond. But it will offer you the wrong hand,
              your reflection is false. Words breakdown; reverse; hold no
              meaning.
              <br />
              <br />
              Inside the work you can see layers of reality expand away from you
              like multiverse. Each one is a reflection of the previous, a
              meticulous fantasy, where the rules of the previous are reversed
              and therefore become synchronous with the grandparent universe.
              <br />
              <br />
              The first explores Human and Machine. The world of machine is
              noise. Layers of complex deterministic randomness. True randomness
              is not allowed by our universe. The world of humans is
              interpretation. We look at the noise and see what we want, what we
              need or what we fear. In machines, perhaps what we fear, is
              ourselves.
            </p>
          </div>
          <div className="grid-element">
            <div>
              <img src="assets/images/SS-70_2.jpg" alt="SS #1" />
            </div>
            <div className="description">
              <h5 style={{ marginBottom: 0 }}>Super Symmetry</h5>
              <p>Code, digital canvas, screen & frame</p>
              <p>70 x 70cm. (Depth 12cm) </p>
              <p>
                <small>£7,000</small>
              </p>
              <Link className="link" to="/enquiries">
                Enquiries & Purchases
              </Link>
            </div>
          </div>
        </section>
        <section id="artist">
          <h2>Meet the Artist</h2>
          <div className="grid">
            <p>
              Sam is a generative, digital and installation artist, working with
              electrical, mechanical and coded parts. Sam always develops new
              mediums of display; creating a unique sense of depth and
              perspective.
              <br />
              <br />
              Sam explores the relationship between truth and fiction in our
              perception of reality. Sam draws on mathematical and scientific
              theories, generating complex abstractions and deterministic
              patterns.
              <br />
              <br />
              If you are a gallery, institution or need any other info, please
              email, this address. Sam Fazakerley is also the founder of Cornell
              Box Ltd. Cornell Box handles all requests for brand collaboration,
              corporate installations and adaptations of the work. For any
              commercial enquiries, please contact this address or visit
              www.cornellbox.studio.
            </p>
            <div className="grid-element artist-video">
              <Video
                portrait={true}
                fullMp="assets/videos/meet_the_artist.mp4"
                fullWebm="assets/videos/meet_the_artist.webm"
                classes={"insta-video"}
              />
            </div>
          </div>
        </section>
        <section id="news">
          <h2>News & Updates</h2>
          <p>
            If you would like to receive invites to upcoming shows, be kept up
            to date about new works and the sale of works, add your details to
            the form below. Or follow on instagram.
          </p>
          <NewsForm />
        </section>
        <Footer />
      </div>
    </>
  );
};
